import * as Models from './generated_models'
import * as Immutable from 'immutable'
import * as Moment from 'moment'
import 'whatwg-fetch'
import {
  UrlTemplate, application, get_context, Route, Url, make_url, fallback_url, link_to_route,
  Option, C, Mode, unit, bind, string, number, bool, button, selector, some, none, multi_selector, label, h1, h2, div, form, image, link, file, overlay,
  custom, repeat, all, any, lift_promise, retract, delay,
  simple_menu, mk_menu_entry, mk_submenu_entry, MenuEntry, MenuEntryValue, MenuEntrySubMenu,
  rich_text, paginate, Page, list, editable_list
} from 'monadic_react'
import { LoginData, ResetData, ApiResult, ApiResultWithMessage, RegisterData, InviteData, ChangeData} from 'monadic_react_lib';
import { SearchQueryItem } from './generated_views/view_utils';

export type ItemWithEditable<T> = {Item:T, Editable:boolean, JustCreated:boolean}

export type RawPage<T> = {
  Items:ItemWithEditable<T>[]
  PageIndex:number
  SearchQuery:string
  NumPages:number
  PageSize:number
  TotalCount:number
  CanCreate:boolean
  CanDelete:boolean
}

export let parse_date = <T>(e:any) : T&{CreatedDate:Moment.Moment} => { return { ...e, CreatedDate: Moment.utc(e.CreatedDate) }}

export let make_page = <T>(res:any, parse_other_args:(e:any) => T) : RawPage<T> => { return {
  Items: res.Items.map((i:any) => { return{ ...i, Item:parse_date(i.Item)} }).map((i:any) => { return{ ...i, Item:parse_other_args(i.Item)} }),
  PageIndex: res.PageIndex,
  SearchQuery:res.SearchQuery,
  NumPages: res.NumPages,
  PageSize: res.PageSize,
  TotalCount: res.TotalCount,
  CanCreate: res.CanCreate,
  CanDelete: res.CanDelete
}}

var _global_project_name: string = null;
export let project_name_set = (project_name: string) => _global_project_name = project_name
export let project_name_get = () => (_global_project_name === null) ? "" : _global_project_name

export async function get_Application_Application_Admins(source:Models.Application, page_index:number, page_size:number) : Promise<RawPage<Models.Admin>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/Application/${source.Id}/Application_Admins?page_index=${page_index}&page_size=${page_size}`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return make_page<Models.Admin>(json, e => { return {...e, }})
}







export async function get_Application_Application_Admins_Admin(source:Models.Application, page_index:number, page_size:number, id:number) : Promise<Models.Admin> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/Application/${source.Id}/Application_Admins/${id}`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return {...json, CreatedDate: Moment.utc(json.CreatedDate),  } as Models.Admin
}

export async function get_Application_Application_Admins_Admin_by_id(source:Models.Application, id:number) : Promise<Models.Admin> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/Application/${source.Id}/Application_Admins/${id}`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return {...json, CreatedDate: Moment.utc(json.CreatedDate),  } as Models.Admin
}




export async function get_Application_Application_Users(source:Models.Application, page_index:number, page_size:number) : Promise<RawPage<Models.User>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/Application/${source.Id}/Application_Users?page_index=${page_index}&page_size=${page_size}`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return make_page<Models.User>(json, e => { return {...e, }})
}







export async function get_Application_Application_Users_User(source:Models.Application, page_index:number, page_size:number, id:number) : Promise<Models.User> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/Application/${source.Id}/Application_Users/${id}`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return {...json, CreatedDate: Moment.utc(json.CreatedDate),  } as Models.User
}

export async function get_Application_Application_Users_User_by_id(source:Models.Application, id:number) : Promise<Models.User> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/Application/${source.Id}/Application_Users/${id}`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return {...json, CreatedDate: Moment.utc(json.CreatedDate),  } as Models.User
}




export async function create_Application() : Promise<Models.Application> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

  let res = await fetch(`/api/v1/Application/`, { method: 'post', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return {...json, CreatedDate: Moment.utc(json.CreatedDate),  } as Models.Application
}

export async function update_Application(item:Models.Application) : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

  let res = await fetch(`/api/v1/Application/`, { method: 'put',
      body: JSON.stringify({...item, CreatedDate:undefined, }), credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  return
}

export async function update_Application_with_pictures(item:Models.Application) : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

  let res = await fetch(`/api/v1/Application/WithPictures`, { method: 'put',
      body: JSON.stringify({...item, CreatedDate:undefined}), credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  return
}

export async function delete_Application(source:Models.Application) : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
  let res = await fetch(`/api/v1/Application/${source.Id}`, { method: 'delete', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  return
}

export async function get_Application(id:number) : Promise<ItemWithEditable<Models.Application>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/Application/${id}`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return { Item: {...json.Item, CreatedDate: Moment.utc(json.Item.CreatedDate),  } as Models.Application,
           Editable: !!json.Editable, JustCreated:false }
}

export async function get_Application_with_pictures(id:number) : Promise<ItemWithEditable<Models.Application>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/Application/${id}/WithPictures`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return { Item: {...json.Item, CreatedDate: Moment.utc(json.Item.CreatedDate),  } as Models.Application,
           Editable: !!json.Editable, JustCreated:false }
}

export async function get_Applications(page_index:number, page_size:number) : Promise<RawPage<Models.Application>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/Application?page_index=${page_index}&page_size=${page_size}`, { method: 'get', credentials: 'include', headers: headers })

  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return make_page<Models.Application>(json, e => { return {...e, }})
}










  
  
export async function get_Admin_Application_Admins(source:Models.Admin, page_index:number, page_size:number) : Promise<RawPage<Models.Application>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/Admin/${source.Id}/Admin_Applications?page_index=${page_index}&page_size=${page_size}`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return make_page<Models.Application>(json, e => { return {...e, }})
}







export async function get_Admin_Application_Admins_Application(source:Models.Admin, page_index:number, page_size:number, id:number) : Promise<Models.Application> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/Admin/${source.Id}/Admin_Applications/${id}`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return {...json, CreatedDate: Moment.utc(json.CreatedDate),  } as Models.Application
}

export async function get_Admin_Application_Admins_Application_by_id(source:Models.Admin, id:number) : Promise<Models.Application> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/Admin/${source.Id}/Admin_Applications/${id}`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return {...json, CreatedDate: Moment.utc(json.CreatedDate),  } as Models.Application
}




export async function create_Admin() : Promise<Models.Admin> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

  let res = await fetch(`/api/v1/Admin/`, { method: 'post', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return {...json, CreatedDate: Moment.utc(json.CreatedDate),  } as Models.Admin
}

export async function update_Admin(item:Models.Admin) : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

  let res = await fetch(`/api/v1/Admin/`, { method: 'put',
      body: JSON.stringify({...item, CreatedDate:undefined, }), credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  return
}

export async function update_Admin_with_pictures(item:Models.Admin) : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

  let res = await fetch(`/api/v1/Admin/WithPictures`, { method: 'put',
      body: JSON.stringify({...item, CreatedDate:undefined}), credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  return
}

export async function delete_Admin(source:Models.Admin) : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
  let res = await fetch(`/api/v1/Admin/${source.Id}`, { method: 'delete', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  return
}

export async function get_Admin(id:number) : Promise<ItemWithEditable<Models.Admin>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/Admin/${id}`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return { Item: {...json.Item, CreatedDate: Moment.utc(json.Item.CreatedDate),  } as Models.Admin,
           Editable: !!json.Editable, JustCreated:false }
}

export async function get_Admin_with_pictures(id:number) : Promise<ItemWithEditable<Models.Admin>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/Admin/${id}/WithPictures`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return { Item: {...json.Item, CreatedDate: Moment.utc(json.Item.CreatedDate),  } as Models.Admin,
           Editable: !!json.Editable, JustCreated:false }
}

export async function get_Admins(page_index:number, page_size:number) : Promise<RawPage<Models.Admin>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/Admin?page_index=${page_index}&page_size=${page_size}`, { method: 'get', credentials: 'include', headers: headers })

  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return make_page<Models.Admin>(json, e => { return {...e, }})
}










export async function delete_Admin_sessions() : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

  let res = await fetch(`/api/v1/Admin/DeleteSessions`,
    { method: 'post', credentials: 'include',
      headers: headers
    })
  return
}

export async function active_Admin_sessions() : Promise<Array<{Item1: string, Item2: Date}>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

  let res = await fetch(`/api/v1/Admin/ActiveSessions`,
    { method: 'post', credentials: 'include',
      headers: headers
    })
  if (!res.ok) return []
  let json = await res.json()
  return json as Array<{Item1: string, Item2: Date}>
}

export async function change_Admin_Email(oldEmail:string, newEmail: string, password: string) : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
  
  let res = await fetch(`/api/v1/Admin/ChangeEmail`,
    { method: 'post', credentials: 'include',
      body: JSON.stringify({OldEmail: oldEmail, NewEmail: newEmail, Password: password}),
      headers: headers})
    if (!res.ok) throw Error(res.statusText)
    return
}

export async function verify_Admin_EmailToken(oldEmail:string, newEmail: string, token: string) : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
  
  let res = await fetch(`/api/v1/Admin/ChangeEmailConfirm`,
    { method: 'post', credentials: 'include',
      body: JSON.stringify({OldEmail:oldEmail, NewEmail: newEmail, Token: token}),
      headers: headers})
    if (!res.ok) throw Error(res.statusText)
    return
}

export async function change_Admin_Username(email: string, username: string, password: string) : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
  
  let res = await fetch(`/api/v1/Admin/ChangeUsername`,
    { method: 'post', credentials: 'include',
      body: JSON.stringify({Email: email, Username: username, Password: password}),
      headers: headers})
    if (!res.ok) throw Error(res.statusText)
    return
}

export async function change_Admin_password(username:string, email:string, password:string, new_password:string, new_password_confirmation:string) : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
  
  let res = await fetch(`/api/v1/Admin/ChangePassword`,
    { method: 'post', credentials: 'include',
      body: JSON.stringify({Username:username, Email:email, Password:password, NewPassword:new_password, NewPasswordConfirmation:new_password_confirmation}),
      headers: headers })
  if (!res.ok) throw Error(res.statusText)
  return
}
  
  
export async function get_User_Application_Users(source:Models.User, page_index:number, page_size:number) : Promise<RawPage<Models.Application>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/User/${source.Id}/User_Applications?page_index=${page_index}&page_size=${page_size}`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return make_page<Models.Application>(json, e => { return {...e, }})
}







export async function get_User_Application_Users_Application(source:Models.User, page_index:number, page_size:number, id:number) : Promise<Models.Application> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/User/${source.Id}/User_Applications/${id}`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return {...json, CreatedDate: Moment.utc(json.CreatedDate),  } as Models.Application
}

export async function get_User_Application_Users_Application_by_id(source:Models.User, id:number) : Promise<Models.Application> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/User/${source.Id}/User_Applications/${id}`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return {...json, CreatedDate: Moment.utc(json.CreatedDate),  } as Models.Application
}




export async function create_User() : Promise<Models.User> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

  let res = await fetch(`/api/v1/User/`, { method: 'post', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return {...json, CreatedDate: Moment.utc(json.CreatedDate),  } as Models.User
}

export async function update_User(item:Models.User) : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

  let res = await fetch(`/api/v1/User/`, { method: 'put',
      body: JSON.stringify({...item, CreatedDate:undefined, }), credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  return
}

export async function update_User_with_pictures(item:Models.User) : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

  let res = await fetch(`/api/v1/User/WithPictures`, { method: 'put',
      body: JSON.stringify({...item, CreatedDate:undefined}), credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  return
}

export async function delete_User(source:Models.User) : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
  let res = await fetch(`/api/v1/User/${source.Id}`, { method: 'delete', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  return
}

export async function get_User(id:number) : Promise<ItemWithEditable<Models.User>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/User/${id}`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return { Item: {...json.Item, CreatedDate: Moment.utc(json.Item.CreatedDate),  } as Models.User,
           Editable: !!json.Editable, JustCreated:false }
}

export async function get_User_with_pictures(id:number) : Promise<ItemWithEditable<Models.User>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/User/${id}/WithPictures`, { method: 'get', credentials: 'include', headers: headers })
  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return { Item: {...json.Item, CreatedDate: Moment.utc(json.Item.CreatedDate),  } as Models.User,
           Editable: !!json.Editable, JustCreated:false }
}

export async function get_Users(page_index:number, page_size:number) : Promise<RawPage<Models.User>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/User?page_index=${page_index}&page_size=${page_size}`, { method: 'get', credentials: 'include', headers: headers })

  if (!res.ok) throw Error(res.statusText)
  let json = await res.json()
  return make_page<Models.User>(json, e => { return {...e, }})
}










export async function delete_User_sessions() : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

  let res = await fetch(`/api/v1/User/DeleteSessions`,
    { method: 'post', credentials: 'include',
      headers: headers
    })
  return
}

export async function active_User_sessions() : Promise<Array<{Item1: string, Item2: Date}>> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

  let res = await fetch(`/api/v1/User/ActiveSessions`,
    { method: 'post', credentials: 'include',
      headers: headers
    })
  if (!res.ok) return []
  let json = await res.json()
  return json as Array<{Item1: string, Item2: Date}>
}

export async function change_User_Email(oldEmail:string, newEmail: string, password: string) : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
  
  let res = await fetch(`/api/v1/User/ChangeEmail`,
    { method: 'post', credentials: 'include',
      body: JSON.stringify({OldEmail: oldEmail, NewEmail: newEmail, Password: password}),
      headers: headers})
    if (!res.ok) throw Error(res.statusText)
    return
}

export async function verify_User_EmailToken(oldEmail:string, newEmail: string, token: string) : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
  
  let res = await fetch(`/api/v1/User/ChangeEmailConfirm`,
    { method: 'post', credentials: 'include',
      body: JSON.stringify({OldEmail:oldEmail, NewEmail: newEmail, Token: token}),
      headers: headers})
    if (!res.ok) throw Error(res.statusText)
    return
}

export async function change_User_Username(email: string, username: string, password: string) : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
  
  let res = await fetch(`/api/v1/User/ChangeUsername`,
    { method: 'post', credentials: 'include',
      body: JSON.stringify({Email: email, Username: username, Password: password}),
      headers: headers})
    if (!res.ok) throw Error(res.statusText)
    return
}

export async function change_User_password(username:string, email:string, password:string, new_password:string, new_password_confirmation:string) : Promise<void> {
  let headers = new Headers()
  headers.append('content-type', 'application/json')
  headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
  
  let res = await fetch(`/api/v1/User/ChangePassword`,
    { method: 'post', credentials: 'include',
      body: JSON.stringify({Username:username, Email:email, Password:password, NewPassword:new_password, NewPasswordConfirmation:new_password_confirmation}),
      headers: headers })
  if (!res.ok) throw Error(res.statusText)
  return
}
  
  
export async function login_promise(ld: LoginData<string>): Promise<ApiResultWithMessage<any>> {
    try {
        let headers = new Headers()
        headers.append('content-type', 'application/json')
        headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

        let res = await fetch('/api/v1/' + ld.role + '/Login',
            {
                method: 'post', credentials: 'include',
                body: JSON.stringify({ Email: ld.email, Password: ld.password }),
                headers: headers
            })

        if (!res.ok && res.status != 401 && res.status != 403) {
          throw (res.statusText)
        } else if (!res.ok) {
          let json = await res.json() as {message: string}
          throw (json.message !== undefined ? json.message : "login_failed")
        }

        let json = await res.json() as ApiResultWithMessage<any>

        return json.status == "failure" ? {status: "failure", message: json.message} : {status: "success", user: json.user}

    } catch (error) {
        return {status: "failure", message: error.toString()}
    }
}

export async function logout_promise(ld: LoginData<string>) : Promise<void> {
    let headers = new Headers()
    headers.append('content-type', 'application/json')
    headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

    let res = await fetch('/api/v1/' + ld.role + '/Logout',
        {
            method: 'post', credentials: 'include',
            headers: headers
        })

    if (!res.ok) throw Error(res.statusText)
    return
  }

export async function forgot_password_promise(ld: LoginData<string>): Promise<ApiResult> {
    try {
        let headers = new Headers()
        headers.append('content-type', 'application/json')
        headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

        let res = await fetch('/api/v1/' + ld.role + '/ForgotPassword',
            {
                method: 'post', credentials: 'include',
                body: JSON.stringify({ Email: ld.email }),
                headers: headers
            })

        if (!res.ok) throw Error(res.statusText)
        return "success"
    } catch (error) {
        return "failure"
    }
}

export async function reset_password_promise(rd: ResetData<string>): Promise<ApiResult> {
    try {
        let headers = new Headers()
        headers.append('content-type', 'application/json')
        headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

        let res = await fetch('/api/v1/' + rd.role + '/ResetPassword',
        {
          method: 'post', credentials: 'include',
          body: JSON.stringify({ Email: rd.email, Password: rd.new_password, ConfirmPassword: rd.new_password_confirm, Token: rd.token }),
          headers: headers
        })
      if (!res.ok) throw Error(res.statusText)
        return "success"
    } catch (error) {
      return "failure"
    }
  }

export async function register_promise(rd: RegisterData<string>): Promise<ApiResultWithMessage<any>> {
    try {
      let headers = new Headers()
      headers.append('content-type', 'application/json')
      headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
      
      let res = await fetch('/api/v1/' + rd.role + '/Register',
        { method: 'post', credentials: 'include',
          body: JSON.stringify({Username:rd.username, Email:rd.email, EmailConfirmation:rd.emailConfirmation, Password: rd.password, PasswordConfirmation: rd.passwordConfirmation}),
          headers: headers
        })
      if (!res.ok) throw Error(res.statusText)

      let json = await res.json()
      return {status: "success", user: json}

    } catch (error) {
      return {status: "failure", message: "register_failed"}
    }
}

export async function invite_promise(rd: InviteData<string>): Promise<ApiResultWithMessage<any>> {
    try {
      let headers = new Headers()
      headers.append('content-type', 'application/json')
      headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
      
      let res = await fetch('/api/v1/' + rd.role + '/Invite',
        { method: 'post', credentials: 'include',
          body: JSON.stringify({Username:rd.username, Firstname: rd.firstname, Lastname: rd.lastname, Email:rd.email, EmailConfirmation:rd.emailConfirmation}),
          headers: headers
        })
      if (!res.ok) throw Error(res.statusText)

      let json = await res.json()
      return {status: "success", user: json}

    } catch (error) {
      console.log(error)
      return {status: "failure", message: "invite_failed"}
    }
}

export async function change_password_promise(cd: ChangeData) : Promise<ApiResult> {
    try {
      let headers = new Headers()
      headers.append('content-type', 'application/json')
      headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
      
      let res = await fetch('/api/v1/Admin/ChangePassword',
        { method: 'post', credentials: 'include',
          body: JSON.stringify({Password:cd.password, NewPassword:cd.newPassword, NewPasswordConfirmation:cd.newPasswordConfirmation}),
          headers: headers })
      if (!res.ok) throw Error(res.statusText)
        return "success"
    } catch (error) {
      return "failure"
    }
}

export function login(loginData: LoginData<string>) {
    return lift_promise<LoginData<string>, ApiResultWithMessage<any>>(ld => login_promise(ld), "semi exponential")(loginData);
}

export function logout(loginData: LoginData<string>) {
    return lift_promise<LoginData<string>, void>(ld => logout_promise(ld), "semi exponential")(loginData);
}

export function forgot_password(loginData: LoginData<string>) {
    return lift_promise<LoginData<string>, ApiResult>(ld => forgot_password_promise(ld), "semi exponential")(loginData);
}

export function reset_password(resetData: ResetData<string>) {
    return lift_promise<ResetData<string>, ApiResult>(rd => reset_password_promise(rd), "semi exponential")(resetData);
}

export function register(registerData: RegisterData<string>) {
    return lift_promise<RegisterData<string>, ApiResultWithMessage<any>>(rd => register_promise(rd), "semi exponential")(registerData);
}

export function invite(inviteData: InviteData<string>) {
    return lift_promise<InviteData<string>, ApiResultWithMessage<any>>(rd => invite_promise(rd), "semi exponential")(inviteData);
}

export function change_password(changeData: ChangeData) {
    return lift_promise<ChangeData, ApiResult>(cd => change_password_promise(cd), "semi exponential")(changeData);
}
  

  